import React from 'react';

import Typography from '@mui/material/Typography';

import { FiAlertCircle } from 'react-icons/fi';

import { ContainerStyled, MessageContainerStyled } from './styles';

function NoPermissions() {
  return (
    <ContainerStyled>
      <FiAlertCircle color="#fbbd08" fontSize="3em" />
      <MessageContainerStyled>
        <Typography component="h3" variant="h3">
          Você não possui permissão para acessar esta área.
        </Typography>
        <Typography component="h3" variant="h3">
          Contate o administrador.
        </Typography>
      </MessageContainerStyled>
    </ContainerStyled>
  );
}

export default NoPermissions;
